/**
 * 响应式断点判定（单一数据源，全局共享）
 * 桌面端与手机端共用一套组件，靠这个状态切换渲染形态：
 *   - 宽屏（>= 900px）：表格视图 + 侧边导航
 *   - 窄屏（< 900px）：卡片视图 + 底部导航
 * 用窗口宽度而不是 UA 判定，平板、手机横竖屏、浏览器缩窗都能正确响应。
 */
import Vue from 'vue';

// 与 global.scss 中的 $bp-desktop 保持一致
export const DESKTOP_BREAKPOINT = 900;

const state = Vue.observable({
  isMobile: typeof window !== 'undefined' && window.innerWidth < DESKTOP_BREAKPOINT
});

let bound = false;

function sync() {
  const next = window.innerWidth < DESKTOP_BREAKPOINT;
  if (next !== state.isMobile) state.isMobile = next;
}

// 在 main.js 里调用一次即可
export function initResponsive() {
  if (bound || typeof window === 'undefined') return;
  bound = true;
  sync();
  window.addEventListener('resize', sync, { passive: true });
  window.addEventListener('orientationchange', sync, { passive: true });
}

export default state;
